import React, {Component} from "react";
import {Redirect} from 'react-router';

import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import SearchComponentReport from "components/Search/AutoCompleteReportTitle.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components

import SearchComponent from "components/Search/AutoCompletePatient.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber, currentDate,
    verifyPhoneNumber,
    getReportTypes, isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter
} from '../../util/globalHelper'

// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import ReportUpload from "../CustomUpload/ReportUpload";
import Loader from '../../components/Loader'

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);

        }
    }
    return arr;
}


class AddReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: true,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            autoCompleteValue: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            clinicmaster_id: "",
            clinic_id: "",
            patient: null,
            clinicsData: null,
            autoCompleteReportValue: ""
        };
        this.typeClick = this.typeClick.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.setPhoneNumber = this.setPhoneNumber.bind(this)
        this.setReportTitle = this.setReportTitle.bind(this)
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    handleImageUrl(url) {
        var reportCount = this.state.report_link.length > 0 ? this.state.report_link.length : "";
        this.setState({
            // imageurl: url,
            report_link: this.state.report_link.concat({
                "link": url,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`
            })
        }, () => {
            // this.setState({imageurl: ''})
        });
    }

    removeReport(url) {
        this.setState({report_link: this.state.report_link.splice(this.state.report_link.indexOf(this.state.report_link.find(item => item.link === url)), 1)})
    }

    changeExistingReport(url, preUrl) {
        let objIndex = this.state.report_link.length > 0 ? this.state.report_link.findIndex((obj => obj.link === preUrl)) : null;
        if (this.state.report_link.length > 0 && this.state.report_link[objIndex] !== undefined) {
            this.state.report_link[objIndex].link = url
        }
    }

    getSuggestionValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name,
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
        });
        return suggestion.user_id.contact

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID)
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({
            clinicMasterList: {},
            clinicmaster_id: clinicmaster_id(),
            clinic_id: getClinicUserId()
        });
        var postBody = {
            "clinic_master_id": clinicmaster_id(),
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name, nameState: 'success',
                        autoCompleteValue: this.state.patientDetail.user_id.contact,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        contactNumberState: 'success',
                        email: this.state.patientDetail.user_id.email,
                        emailState: 'success',
                    })
                })
            })
        }
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    setReportTitle(value) {
        this.setState({autoCompleteReportValue: value})
    }

    getReportTitleSuggestionValue = (suggestion) => {
        this.setState({
            report: suggestion,
            reportTitle: suggestion.title,
            simpleSelect: suggestion.type,
            description: suggestion.description,
            descriptionState: 'success'
        });
        return suggestion.title

    };

    componentWillUnmount() {
        this.setState({
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: true,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
        })

    }

    render() {
        const {classes} = this.props;
        const {clinicLis, clinicsData, clinicMasterList} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && (this.state.clinicsData[0] ? this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id : true) || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>New Report</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            {isClinicMasterOrClinic() === "" ?
                                                <GridItem xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicMasterList.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <br/>
                                                </GridItem> : null}
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
                                                <GridItem xs={12} sm={6} className="centerDiv">

                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem
                                                                    disabled
                                                                >
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.length > 0 ? clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                }) : null}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem> : null}
                                            <GridItem xs={12} sm={6}>

                                                {this.props.id.match.params.patientID ? <CustomInput
                                                        labelText=" Phone Number"
                                                        success={this.state.contactNumberState === "success"}
                                                        error={this.state.contactNumberState === "error"}
                                                        id="url"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                            value: this.state.contactNumber,

                                                        }}
                                                    /> :
                                                    <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                     name={this.state.name}
                                                                     clearPatient={this.clearPatient}
                                                                     getSuggestionValue={this.getSuggestionValue}/>}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <SearchComponentReport autoCompleteReportValue=""
                                                                       setReportTitle={this.setReportTitle}
                                                                       getReportTitleSuggestionValue={this.getReportTitleSuggestionValue}/>

                                                {/*<CustomInput*/}
                                                {/*labelText=" Report Title"*/}
                                                {/*success={this.state.reportTitleState === "success"}*/}
                                                {/*error={this.state.reportTitleState === "error"}*/}
                                                {/*id="reportTitle"*/}
                                                {/*formControlProps={{*/}
                                                {/*fullWidth: true,*/}
                                                {/*required: true*/}
                                                {/*}}*/}
                                                {/*inputProps={{*/}
                                                {/*onChange: event =>*/}
                                                {/*this.change(event, "reportTitle", "novalidation"),*/}

                                                {/*}}*/}
                                                {/*/>*/}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Name"
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name"),
                                                        value: this.state.name,

                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}
                                                    style={{marginTop: 10}}>
                                                    <InputLabel
                                                        htmlFor="reportType"
                                                        className={classes.selectLabel}>
                                                        Report Type
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.simpleSelect}
                                                        onChange={this.handleSimple}
                                                        inputProps={{
                                                            name: "simpleSelect",
                                                            id: "simple-select"
                                                        }}
                                                    >
                                                        <MenuItem
                                                            disabled
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            Report Type
                                                        </MenuItem>
                                                        {getReportTypes().map(item => {
                                                            return <MenuItem key={Math.random()}
                                                                             classes={{root: classes.selectMenuItem}}
                                                                             style={{height: "1.8em"}}
                                                                             value={item}>{item}</MenuItem>
                                                        })})}
                                                    </Select>
                                                </FormControl>

                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>

                                                <CustomInput
                                                    labelText="Email"
                                                    success={this.state.emailState === "success"}
                                                    error={this.state.emailState === "error"}
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "email", "email"),
                                                        value: this.state.email,

                                                    }}
                                                />
                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Description"
                                                    success={this.state.descriptionState === "success"}
                                                    error={this.state.descriptionState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "description", "novalidation")
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>

                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.checkedA}
                                                            onChange={this.handleChange("checkedA")}
                                                            value="checkedA"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="No Payment Dues"
                                                />
                                            </GridItem>

                                        </GridContainer>
                                        <Card>
                                            <GridItem>
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{justifyContent: 'center', textAlign: 'center'}}>
                                                    <GridItem xs={12} style={{justifyContent: 'center'}}>
                                                        <br/><br/>
                                                        <Assignment style={{fontSize: 65}}/>

                                                    </GridItem>
                                                    {this.state.report_link.length === 0 ?
                                                        <GridItem xs={12} lg={12}><GridItem xs={12}
                                                                                            style={{justifyContent: 'center'}}>
                                                            <h3>Upload Report Here</h3>
                                                        </GridItem>
                                                            <GridItem xs={12} style={{justifyContent: 'center'}}>
                                                                <h4>Looks like you have no reports yet.<br/> Click on
                                                                    the
                                                                    button
                                                                    below to add reports. <br/><br/>
                                                                </h4>
                                                            </GridItem>
                                                        </GridItem> : <GridItem xs={12}
                                                                                style={{
                                                                                    justifyContent: 'center',
                                                                                    marginBottom: '50px'
                                                                                }}>
                                                            <h3>Reports</h3>
                                                        </GridItem>}
                                                    <GridItem xs={12} sm={12} md={12}
                                                              style={{justifyContent: 'center'}}>
                                                        <ReportUpload addButtonProps={{
                                                            color: "warning",
                                                            round: false,
                                                            size: "lg"
                                                        }}
                                                                      changeButtonProps={{
                                                                          color: "warning",
                                                                          round: true,
                                                                          size: "md"
                                                                      }}
                                                                      removeButtonProps={{
                                                                          color: "danger",
                                                                          round: true,
                                                                          size: "md"
                                                                      }}
                                                                      handleImageUrl={this.handleImageUrl.bind(this)}
                                                                      removeUrl={this.removeReport.bind(this)}
                                                                      imageurl={this.state.imageurl}
                                                                      clinic_id={this.state.clinic_id}
                                                                      changeUrl={this.changeExistingReport.bind(this)}
                                                                      role="Clinic"/><br/><br/>
                                                    </GridItem>
                                                    {this.state.report_link.length > 0 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload addButtonProps={{
                                                                color: "warning",
                                                                round: false,
                                                                size: "lg"
                                                            }}
                                                                          changeButtonProps={{
                                                                              color: "warning",
                                                                              round: false
                                                                          }}
                                                                          removeButtonProps={{
                                                                              color: "danger",
                                                                              round: false
                                                                          }}
                                                                          handleImageUrl={this.handleImageUrl.bind(this)}
                                                                          imageurl={this.state.imageurl}
                                                                          clinic_id={this.state.clinic_id}
                                                                          removeUrl={this.removeReport.bind(this)}
                                                                          changeUrl={this.changeExistingReport.bind(this)}
                                                                          role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}

                                                    {this.state.report_link.length > 1 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload addButtonProps={{
                                                                color: "warning",
                                                                round: false,
                                                                size: "lg"
                                                            }}
                                                                          changeButtonProps={{
                                                                              color: "warning",
                                                                              round: false
                                                                          }}
                                                                          removeButtonProps={{
                                                                              color: "danger",
                                                                              round: false
                                                                          }}
                                                                          handleImageUrl={this.handleImageUrl.bind(this)}
                                                                          imageurl={this.state.imageurl}
                                                                          clinic_id={this.state.clinic_id}
                                                                          removeUrl={this.removeReport.bind(this)}
                                                                          changeUrl={this.changeExistingReport.bind(this)}
                                                                          role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}

                                                    {this.state.report_link.length > 2 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload addButtonProps={{
                                                                color: "warning",
                                                                round: false,
                                                                size: "lg"
                                                            }}
                                                                          changeButtonProps={{
                                                                              color: "warning",
                                                                              round: false
                                                                          }}
                                                                          removeButtonProps={{
                                                                              color: "danger",
                                                                              round: false
                                                                          }}
                                                                          handleImageUrl={this.handleImageUrl.bind(this)}
                                                                          imageurl={this.state.imageurl}
                                                                          clinic_id={this.state.clinic_id}
                                                                          removeUrl={this.removeReport.bind(this)}
                                                                          changeUrl={this.changeExistingReport.bind(this)}
                                                                          role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}
                                                    {this.state.report_link.length > 3 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload
                                                                addButtonProps={{color: "warning", round: false}}
                                                                changeButtonProps={{
                                                                    color: "warning",
                                                                    round: false
                                                                }}
                                                                removeButtonProps={{
                                                                    color: "danger",
                                                                    round: false
                                                                }}
                                                                handleImageUrl={this.handleImageUrl.bind(this)}
                                                                imageurl={this.state.imageurl}
                                                                clinic_id={this.state.clinic_id}
                                                                removeUrl={this.removeReport.bind(this)}
                                                                changeUrl={this.changeExistingReport.bind(this)}
                                                                role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}

                                                    {this.state.report_link.length > 4 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload
                                                                addButtonProps={{color: "warning", round: false}}
                                                                changeButtonProps={{
                                                                    color: "warning",
                                                                    round: false
                                                                }}
                                                                removeButtonProps={{
                                                                    color: "danger",
                                                                    round: false
                                                                }}
                                                                handleImageUrl={this.handleImageUrl.bind(this)}
                                                                imageurl={this.state.imageurl}
                                                                clinic_id={this.state.clinic_id}
                                                                removeUrl={this.removeReport.bind(this)}
                                                                changeUrl={this.changeExistingReport.bind(this)}
                                                                role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}

                                                    {this.state.report_link.length > 5 ?
                                                        <GridItem xs={12} sm={12} md={12}
                                                                  style={{justifyContent: 'center'}}>
                                                            <ReportUpload
                                                                addButtonProps={{color: "warning", round: false}}
                                                                changeButtonProps={{
                                                                    color: "warning",
                                                                    round: false
                                                                }}
                                                                removeButtonProps={{
                                                                    color: "danger",
                                                                    round: false
                                                                }}
                                                                handleImageUrl={this.handleImageUrl.bind(this)}
                                                                imageurl={this.state.imageurl}
                                                                clinic_id={this.state.clinic_id}
                                                                removeUrl={this.removeReport.bind(this)}
                                                                changeUrl={this.changeExistingReport.bind(this)}
                                                                role="Clinic"/>
                                                            <br/><br/>
                                                        </GridItem> : null}

                                                </GridContainer>
                                                <br/><br/><br/>
                                            </GridItem>
                                        </Card>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <NavLink to={dashboardRouter(`/reports/readReports`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.clinic_id !== "" && this.state.name && this.state.autoCompleteValue !== "" && this.state.clinicmaster_id && this.state.report_link.length > 0 && this.state.autoCompleteReportValue !== "") {
            var data = this.state.clickedId ? {
                "clinic_id": this.state.clinic_id,
                "patient_id": this.state.clickedId,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                "date": currentDate(),
                "paid": this.state.checkedA,
                "description": this.state.description,
                "report_link": this.state.report_link
            } : {
                "clinic_id": this.state.clinic_id,
                "name": this.state.name,
                "contact": this.state.autoCompleteValue,
                "email": this.state.email,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                "date": currentDate(),
                "paid": this.state.checkedA,
                "description": this.state.description,
                "report_link": this.state.report_link
            };
            api.createReport(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Report Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/report/readReports`));
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    clearPatient = () => {
        this.setState({patient: null, patientId: ""})
    };

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

}

export default withStyles(validationFormsStyle)(AddReport);



// WEBPACK FOOTER //
// ./src/components/Reports/addReport.jsx